
const digest = 'b7aa12909f8a9d4956803e185b7ecdf7405f64ef6df00ebf574d624ec32963b1';
const classes = {"wrapper":"_wrapper_1crv2_1","icon":"_icon_1crv2_13","content":"_content_1crv2_19","title":"_title_1crv2_24","arrow":"_arrow_1crv2_29"};
const css = `._wrapper_1crv2_1 {
  position: relative;
  text-decoration: none;
  background-color: #fff;
  padding: 13px 14px;
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  align-items: center;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  cursor: pointer;
}
._wrapper_1crv2_1 ._icon_1crv2_13 {
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 14px;
}
._wrapper_1crv2_1 ._content_1crv2_19 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
._wrapper_1crv2_1 ._content_1crv2_19 ._title_1crv2_24 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._wrapper_1crv2_1 ._arrow_1crv2_29 {
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e5f3ff;
  background: linear-gradient(0deg, #e5f3ff 0, #f4faff 100%);
  position: relative;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  